import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ICRUDRecord, ITransitionPoolItem} from "../../interfaces";
import {actionAddTransitionItem, actionAddTransitionPool, actionAddTransitionPoolAndItem} from "../../store/actions/user.actions";
import {AppService, LocalStoreService, StoreSelectorsService} from "../../services";
import * as _ from "lodash";
import {convertToXML} from "../../common";

@Component({
    selector: 'app-dialog-preset-transition',
    templateUrl: './dialog-preset-transition.component.html',
    styleUrls: ['./dialog-preset-transition.component.scss']
})
export class DialogPresetTransitionComponent implements OnInit {

    // transitionSelectedModel;
    videoPreviewSource = '';
    presets;

    constructor(public dialogRef: MatDialogRef<any>,
                private storeSelector: StoreSelectorsService,
                private appService: AppService,
                private localStoreService: LocalStoreService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data && data.mode) {
        }
    }

    ngOnInit(): void {
        this.presets = [
            // {
            //     "transition_pool_item_id": "17",
            //     "transition_pool_id": "6",
            //     "transition_item_name": "Mask Rectangular",
            //     "transition_item_data": {
            //         "Transition": {
            //             "$": {
            //                 "name": "TransitionMask",
            //                 "rows": "4",
            //                 "columns": "3",
            //                 "shape": "rect"
            //             }
            //         }
            //     }
            // },
            // {
            //     "transition_pool_item_id": "18",
            //     "transition_pool_id": "6",
            //     "transition_item_name": "Mask Circle",
            //     "transition_item_data": {
            //         "Transition": {
            //             "$": {
            //                 "name": "TransitionMask",
            //                 "rows": "4",
            //                 "columns": "3",
            //                 "shape": "circle"
            //             }
            //         }
            //     }
            // },
            // {
            //     "transition_pool_item_id": "11",
            //     "transition_pool_id": "5",
            //     "transition_item_name": "paper 3D 1",
            //     "transition_item_data": {
            //         "Transition": {
            //             "$": {
            //                 "name": "TransitionAway3D",
            //                 "xLoops": "0.5",
            //                 "yLoops": "0",
            //                 "zLoops": "0",
            //                 "duration": "1.0"
            //             }
            //         }
            //     }
            // },
            // {
            //     "transition_pool_item_id": "12",
            //     "transition_pool_id": "5",
            //     "transition_item_name": "paper 3D 2",
            //     "transition_item_data": {
            //         "Transition": {
            //             "$": {
            //                 "name": "TransitionAway3D",
            //                 "xLoops": "0.0",
            //                 "yLoops": "0.5",
            //                 "zLoops": "0",
            //                 "duration": "1.0"
            //             }
            //         }
            //     }
            // },
            // {
            //     "transition_pool_item_id": "15",
            //     "transition_pool_id": "5",
            //     "transition_item_name": "custom 1",
            //     "transition_item_data": {
            //         "Transition": {
            //             "$": {
            //                 "name": "TransitionAway3D",
            //                 "xLoops": "3",
            //                 "yLoops": "1.5",
            //                 "zLoops": "0",
            //                 "duration": "1.0",
            //                 "zAmplitude": "2"
            //             }
            //         }
            //     }
            // },

            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "fast_fade",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "0",
                            "outY": "0",
                            "outRotation": "20",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "0",
                            "inY": "0",
                            "inRotation": "0",
                            "inPivotX": "0",
                            "inPivotY": "0",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "1"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "fade_slow",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "0",
                            "outY": "0",
                            "outRotation": "360",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "0",
                            "inY": "0",
                            "inRotation": "360",
                            "inPivotX": "0.5",
                            "inPivotY": "0.5",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "3"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "slide_bottom",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "0",
                            "outY": "-1",
                            "outRotation": "20",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "0",
                            "inY": "-1",
                            "inRotation": "0",
                            "inPivotX": "0",
                            "inPivotY": "0",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "2"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "slide_top",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "0",
                            "outY": "1",
                            "outRotation": "20",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "0",
                            "inY": "1",
                            "inRotation": "0",
                            "inPivotX": "0",
                            "inPivotY": "0",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "2"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "shrink",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "1",
                            "outY": "0",
                            "outRotation": "360",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "-1",
                            "inAlpha": "1",
                            "inX": "1",
                            "inY": "0",
                            "inRotation": "360",
                            "inPivotX": "0.5",
                            "inPivotY": "0.5",
                            "inScale": "1",
                            "clip": "1",
                            "duration": "2"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "fade_grow",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "0.0",
                            "outY": "0.0",
                            "outRotation": "20",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0.5",
                            "inAlpha": "1",
                            "inX": "0",
                            "inY": "0",
                            "inRotation": "0",
                            "inPivotX": "0",
                            "inPivotY": "0",
                            "inScale": "0.1",
                            "clip": "1",
                            "duration": "3"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "slide_right",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "-1",
                            "outY": "0",
                            "outRotation": "360",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "-1",
                            "inY": "0",
                            "inRotation": "360",
                            "inPivotX": "0.5",
                            "inPivotY": "0.5",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "2"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "slide_left",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "1",
                            "outY": "0",
                            "outRotation": "360",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "1",
                            "inY": "0",
                            "inRotation": "360",
                            "inPivotX": "0.5",
                            "inPivotY": "0.5",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "2"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "overlap",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "1",
                            "outY": "0",
                            "outRotation": "20",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "-1",
                            "inY": "0",
                            "inRotation": "0",
                            "inPivotX": "0",
                            "inPivotY": "0",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "3"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "fast_overlap",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "1",
                            "outY": "0",
                            "outRotation": "360",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0",
                            "inAlpha": "1",
                            "inX": "-1",
                            "inY": "0",
                            "inRotation": "360",
                            "inPivotX": "0.5",
                            "inPivotY": "0.5",
                            "inScale": "0",
                            "clip": "1",
                            "duration": "1.0"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "opposite_top",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "-1",
                            "outY": "-2",
                            "outRotation": "20",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "0.5",
                            "inAlpha": "1",
                            "inX": "1",
                            "inY": "2",
                            "inRotation": "0",
                            "inPivotX": "0",
                            "inPivotY": "0",
                            "inScale": "0.1",
                            "clip": "1",
                            "duration": "3"
                        }
                    }
                }
            },
            {
                "transition_pool_item_id": "-1",
                "transition_pool_id": "-1",
                "transition_item_name": "opposite_bottom",
                "transition_item_data": {
                    "Transition": {
                        "$": {
                            "name": "Transition2D",
                            "outAlpha": "1",
                            "outX": "1",
                            "outY": "0",
                            "outRotation": "360",
                            "outPivotX": "0.5",
                            "outPivotY": "0.5",
                            "outScale": "-1",
                            "inAlpha": "1",
                            "inX": "1",
                            "inY": "0",
                            "inRotation": "360",
                            "inPivotX": "0.5",
                            "inPivotY": "0.5",
                            "inScale": "1",
                            "clip": "1",
                            "duration": "1.0"
                        }
                    }
                }
            }
        ];
    }

    // onVideoPreviewChanged(e) {
    //     const videoName = this.transitionSelectedModel.transition_item_name.replace(/ /ig, '').toLowerCase() + '.gif';
    //     this.videoPreviewSource = videoName;
    // }

    onPresetSelected(i_value): void {
        if (!i_value) return;
        this.dialogRef.close(i_value);
        // this.associateTransition();
    }

    onCloseDialog(): void {
        // if (!this.transitionSelectedModel) return;
        // this.dialogRef.close(this.transitionSelectedModel);
        // this.associateTransition();
    }

    public addNewPoolAndAssociateTransition(i_transitionPoolItem: ITransitionPoolItem) {
        const poolName = 'Pool-' + _.uniqueId();
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command: 'add',
            primary: 'transition_pool_id',
            table: 'transition_pools',
            body: {
                transition_pool_name: poolName
            },
            id: null
        };
        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            /** important do not update store since server command failed **/
            if (!i_crudReply.serverReply.status) return;
            this.storeSelector.dispatch(actionAddTransitionPool({
                data: {
                    id: i_crudReply.serverReply.id,
                    transition_pool_name: poolName
                }
            }));
            this.associateTransition(i_transitionPoolItem, i_crudReply.serverReply.id);
        });
    }

    public associateTransition(i_transitionPoolItem: ITransitionPoolItem, i_selectedPoolId) {
        i_transitionPoolItem.transition_pool_id = i_selectedPoolId;
        delete i_transitionPoolItem.transition_pool_item_id;
        const updatedItemData = this.convertDataXml(i_transitionPoolItem.transition_item_data);
        const updatedModel = _.cloneDeep(i_transitionPoolItem);
        updatedModel.transition_item_data = updatedItemData;

        /** Add new item to transition pool */
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command: 'add',
            primary: 'transition_pool_item_id',
            table: 'transition_pool_items',
            body: updatedModel,
            id: null
        };
        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            /** important do not update store since server command failed **/
            if (!i_crudReply.serverReply.status) return;
            i_transitionPoolItem.transition_pool_item_id = i_crudReply.serverReply.id;
            this.storeSelector.dispatch(actionAddTransitionItem({data: i_transitionPoolItem}));
            this.storeSelector.dispatch(actionAddTransitionPoolAndItem({poolId: i_selectedPoolId}));
        });
    }

    private convertDataXml(data) {
        if (!data) return null;
        return convertToXML(data, true);
    }

    // private translate(terms) {
    //     return this.translocoService.translate(terms, {}, this.translocoService.getActiveLang());
    // }


}
